import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import constants from '../../../../utility/constants';
import { ContactUsService, AuthenticationService } from '../../../../services';
import { BuyerService } from '../../../../services/buyer.service';
import { environment } from '../../../../../environments/environment';
import { AppValidators } from '../../../../core/validators/app-validators';
import { ContactUs } from '../../../../models';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
})
export class ContactUsComponent implements OnInit {
  captcha = new FormControl();
  contactUsForm: FormGroup;
  loading: boolean;
  submitted: boolean;
  currentUserId: number;
  captchaKey: string;
  isLoggedIn: boolean = false;
  private subscriptions: Array<Subscription> = [];

  fieldMaxLength10 = constants.common.validations.maxLength10;
  fieldMaxLength20 = constants.common.validations.maxLength20;
  fieldMaxLength30 = constants.common.validations.maxLength30;
  fieldMaxLength50 = constants.common.validations.maxLength50;
  fieldMaxLength500 = constants.common.validations.maxLength500;

  constructor(
    private formBuilder: FormBuilder,
    private contactUsService: ContactUsService,
    private toastr: ToastrService,
    private buyerService: BuyerService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.initiateForm();

    this.captchaKey = environment.captchaSiteKey;

    if (this.authenticationService.checkLoggedIn()) {
      this.bindContactUsDetails();
      this.isLoggedIn = true;
    }
  }

  initiateForm() {
    this.contactUsForm = new FormGroup({
      firstName: new FormControl(null, [
        Validators.required,
        AppValidators.onlyAlphaNumeric,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength20),
      ]),
      lastName: new FormControl(null, [
        Validators.required,
        AppValidators.onlyAlphaNumeric,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength20),
      ]),
      email: new FormControl(null, [
        Validators.required,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength50),
        AppValidators.checkEmail,
      ]),
      mobileNumber: new FormControl(null, [
        Validators.required,
        Validators.minLength(this.fieldMaxLength10),
        Validators.maxLength(this.fieldMaxLength30),
        AppValidators.noWhitespace,
        AppValidators.onlyNumericSpecialCharacter,
      ]),
      companyName: new FormControl(null, [
        Validators.required,
        AppValidators.onlyAlphaNumeric,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength50),
      ]),
      message: new FormControl(null, [
        Validators.required,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength500),
      ]),
    });
  }

  bindContactUsDetails() {
    const value = this.authenticationService.currentBuyerValue()?.user.id &&
      this.buyerService
        .getById(this.authenticationService.currentBuyerValue()?.user.id)
        .subscribe(
          (response) => {
            this.contactUsForm.patchValue({
              firstName: response.firstName,
              lastName: response.lastName,
              mobileNumber: response.mobileNumber,
              email: response.email,
              companyName: response.companyName,
            });
          },
          (err) => {
            this.toastr.error(
              err,
              constants.common.toast.errorTitle,
              constants.common.toast.config
            );
          }
        );
        this.subscriptions.push(value)
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;
    let model: ContactUs = {
      firstName: this.contactUsForm.value.firstName,
      lastName: this.contactUsForm.value.lastName,
      mobileNumber: this.contactUsForm.value.mobileNumber,
      email: this.contactUsForm.value.email,
      companyName: this.contactUsForm.value.companyName,
      message: this.contactUsForm.value.message,
    };

    const contactAdd = this.contactUsService.addContactUs(model).subscribe(
      (response) => {
        this.loading = false;
        this.toastr.success(
          response,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.contactUsForm.reset();
      },
      (err) => {
        this.loading = false;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(contactAdd)
  }

  onCancel() {
    this.contactUsForm.reset();
  }
  
  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }
}
